<template>
  <div class="flex items-center gap-2 sm:gap-4 w-full justify-between">
    <div class="flex items-center gap-2 sm:gap-4">
      <div :class="step >= 3 ? 'activeInstitution' : 'inActiveInstitution'">
        <v-hand-heart-outline></v-hand-heart-outline>
      </div>
      <div 
        :class="step >= 3 ? 'text-pdsPrimaryColor' : 'text-gray-300'" 
        class="font-bold text-xl leading-snug"
        >
        Rol & behandelgebieden
      </div>
    </div>
    <div 
       v-if="step > 3"
       class="cursor-pointer text-pdsPrimaryColor text-sm font-semibold" 
       @click="editRoleDetails"
       >
      Wijzigen
    </div>
  </div>
  <div v-if="step == 3">
    <div class="mt-2 flex flex-col">
      <label v-if="selectedtreatmentArea?.data" class="font-bold text-lg leading-6 text-gray-700 mt-4">
        Behandelgebied(en):
        <span class="font-semibold text-sm">
          {{
          details?.treatmentAreas
          ?.filter((a) => a.active)
          .map((a) => a.treatmentArea)
          .join(' , ')
          }} 
        </span>
      </label>
      <label class="font-bold text-base leading-6 text-cyan-900">Voor welke behandelgebieden schrijft u voor?*</label>
      <combo-boxes 
        customClass="text-base leading-6 text-cyan-900" 
        placeholder="Kies behandelgebied"
        :disabledInput="'true'"
        v-model="selectedtreatmentArea" 
        @blur="saveTreatmentArea($event)" 
        :list="treatmentAreaList" 
        :rules="{
          required: true
        }" :disabled="disableTreatmentArea">
      </combo-boxes>
      <div>
        <label class="font-bold text-base leading-6 text-cyan-900">Rol* </label>
        <combo-boxes 
          customClass="text-base leading-6 text-cyan-900" 
          placeholder="Kies een rol" 
          v-model="selectedProfession"
          :list="professionList" 
          :disabledInput="'true'"
          :rules="{
          required: true
        }">
        </combo-boxes>
      </div>
    </div>
  </div>

  <div v-if="step > 3" class="mt-2 text-gray-700 text-sm sm:text-base break-words whitespace-normal">
    <div v-if="selectedtreatmentArea.data" class="font-bold text-sm leading-6 text-cyan-900 mt-4">
      Behandelgebied(en):
       <span class="font-semibold text-sm">{{
        details?.treatmentAreas
        ?.filter((a) => a.active)
        .map((a) => a.treatmentArea)
        .join(' , ')
        }}
      </span>
    </div>
    <div v-if="selectedProfession" class="font-bold text-sm leading-6 text-cyan-900">
      Rol:
      <span class="font-semibold text-sm">{{ selectedProfession.data }} </span>
    </div>
  </div>
  <div v-if="step >= 3" class="pt-2">
    <button :class="{
      'text-center text-white px-5 py-3 rounded-full border bg-gray-300 border-gray-300 cursor-default':
        !disableSave,
      'text-center text-white cursor-pointer bg-pdsPrimaryColor px-5 py-3 rounded-full border border-pdsPrimaryColor':
        disableSave
    }" 
    @click.once.prevent="saveProfessionDetails">
      Registratie voltooien
    </button>
  </div>
</template>

<script>
import { ref, onMounted, computed} from 'vue';
import VHandHeartOutline from 'icons/HandHeartOutline';
import { useStore } from 'vuex';
import axios from 'axios';

export default {
  name: 'accountRegistrationRoleDetail',
  components: { VHandHeartOutline },
  props: {
    details: {
      type: Object,
      required: true
    },
    step: { type: Number, default: 0 }
  },
  emits: ['setRoleDetails'],
  setup(props, { emit }) {
    const store = useStore();
    const selectedtreatmentArea = ref({ id: '', data: '' });
    const selectedProfession = ref({ id: '', data: '' });
    const treatmentAreaList = ref([]);
    const professionList = ref([]);
    const disableTreatmentArea = ref(false);
    const isThuisServiceSelected = ref(false);
    const setProfession = (value) => store.commit('accountRegistration/setProfession', value);
    const setPrescriberTreatmentArea = (value) => store.commit('accountRegistration/setPrescriberTreatmentArea', value);
    const resetPrescriberTreatmentArea = (value) => store.commit('accountRegistration/clearPrescriberTreatmentAreas');
    const disableSave = computed(() => {
      if (selectedProfession.value?.id && selectedtreatmentArea?.value.id) {
        return true;
      } else {
        return false;
      }
    });
  
    const getTreatmentAreaList = () => {
      if (props.details && props.details.treatmentAreas) {
        let treatmentAreas = props.details.treatmentAreas;
        treatmentAreas.map((element, item) => {
          treatmentAreaList.value.push({ id: element.treatmentAreaId, data: element.treatmentArea });
        });
      }
    };
    
     const getProfessions = async () => {
      return await axios.get('Registration/GetProfessions').then((response) => {
        response.data.map((element, item) => {
          professionList.value.push({ id: element.professionId, data: element.professionName });
        });
      });
    };
    function saveProfessionDetails () {
      if (selectedProfession.value) {
        setProfession(selectedProfession.value.id);
        emit('setRoleDetails', 4);
      }
    };
    const saveTreatmentArea = () => {
      if (selectedtreatmentArea.value.id) {
        //user selects ThuisService, they should automatically be assigned to the following:
        if (selectedtreatmentArea.value.id == '0000') {
          isThuisServiceSelected.value = true;
          setPrescriberTreatmentArea({ id: '1003', active: true, isThuisService : isThuisServiceSelected.value  });
        }
        else {
          isThuisServiceSelected.value = false;
          setPrescriberTreatmentArea({ id: selectedtreatmentArea.value.id, active: true, isThuisService : false });
        }
      }
    };
    const editRoleDetails = () => {
      disableTreatmentArea.value = false;
      resetPrescriberTreatmentArea();
      selectedtreatmentArea.value = null;
      selectedProfession.value = null;
      emit('setRoleDetails', 3);
    };
    onMounted(() => {
      getTreatmentAreaList();
      getProfessions();
     
    });

    return {
      treatmentAreaList,
      selectedtreatmentArea,
      saveTreatmentArea,
      professionList,
      selectedProfession,
      saveProfessionDetails,
      editRoleDetails,
      disableTreatmentArea,
      disableSave,
      isThuisServiceSelected
    };
  }
};
</script>
<style lang="scss" scoped>
.activeInstitution {
  .material-design-icon,
  :deep(.material-design-icon) {
    fill: $teal-darkest;
  }
}
.inActiveInstitution {
  .material-design-icon,
  :deep(.material-design-icon) {
    fill: $gray-lighter;
  }
}
</style>
